const es = {
  'home-welcome': 'Bienvenido, haga clic para entrar con su cuenta y empezar a explorar la aplicación',
  'home-login-button': 'Entrar',
  'home-section-1-title': '¡Comparta billetes con todo el mundo!',
  'home-section-1-p': '¡Bilhetinhos es una red social minimalista, que le permite interactuar con aquellas personas queridas por usted!',
  'home-section-2-title': '¡Aviso!',
  'home-section-2-p': 'Este sitio se encuentra en construcción y puede sufrir severos cambios y / o pérdida de datos durante el proceso.',
  'footer-by': 'Desarrollado por ',
  'fab-actions': 'Acciones',
  'fab-new-note': 'Nuevo billete',
  'fab-new-mate': 'Añadir colega',
  'fab-scroll-to-top': 'Volver al comienzo',
  'navbar-btn-noteboard': 'Mi cuadro',
  'navbar-btn-mates': 'Colegas',
  'navbar-usermenu-default-label': 'Menú del usuario',
  'navbar-notifications-default-label': 'Notificaciones',
  'notifications-default-label': 'Todo actualizado por aquí!',
  'notifications-clear-all': 'Quitar todas las notificaciones',
  'user-menu-btn-profile': 'Perfil',
  'user-menu-btn-settings': 'Ajustes',
  'user-menu-signout': 'Salir',
  'warning-modal-title': '¿Está seguro?',
  'warning-modal-subtitle': '¡ACCTENCIÓN!',
  'warning-modal-btn-yes': 'Sí, continuar',
  'warning-modal-btn-cancel': 'Cancelar',
  'remove-mate-modal-question': "Usted está a punto de excluir al colega {mateNameOrEmail}. Esta acción NO PUEDE ser deshecha. ¿Desea continuar?",
  'remove-note-modal-question': "Usted está a punto de excluir el billete {noteTitle}. Esta acción NO PUEDE ser deshecha. ¿Desea continuar?",
  'toastr-success-title': 'Éxito!',
  'toastr-error-title': 'Error!',
  'toastr-attention-title': 'Actención!',
  'toastr-error-trying-load-mates': 'Se produjo un error al cargar los colegas).',
  'toastr-notification-sent': "Su notificación ha sido enviada",
  'toastr-maintenance-title': '¡Servidor en mantenimiento!',
  'toastr-maintenance-message': 'Se recomienda encarecidamente que no utilice este sitio durante el mantenimiento, ya que sus datos pueden verse comprometidos. Gracias!',
  'profile-saved': 'Los datos del perfil se han guardado.',
  'profile-image-loading-error': 'No se pudo cargar la imagen',
  'profile-image-updated': "Su imagen de perfil ha sido actualizada con éxito!",
  'profile-cover-image-updated': 'Su imagen de portada ha sido actualizada con éxito',
  'profile-image-error-size-or-type': "El tamaño máximo de los archivos de imagen debe ser de 500 KB. Sólo se aceptan archivos en los formatos jpg, jpeg y png.",
  'profile-header-title': "Perfil",
  'profile-name-placeholder': "Su nombre completo o apellido",
  'profile-bio-placeholder': "Biografía",
  'profile-phone-placeholder': "Número de teléfono",
  'profile-btn-save': "Guardar",
  'profile-picture-label': 'Imagen de perfil',
  'profile-cover-image-label': 'Imagen de portada',
  'profile-pic-input-placeholder': 'Pegue la URL de la imagen aquí y de enter',
  'profile-picture-upload-tip': 'o haga clic en la imagen de abajo y suba',
  'mates-alert-title': 'Invitación de amistad',
  'mates-alert-description': 'Haga clic para agregar el {userEmail}',
  'mates-list-header-label': "Colegas",
  'mates-new-mate-email-placeholder': "Introduzca el E-mail de su colega aquí",
  'mates-add-mate': "Añadir colega",
  'mates-no-mates-label': "Usted no tiene ningún colega",
  'mates-pending-invite': 'Invitación pendiente',
  'mates-decline-invitation-title': 'Invitación cancelada',
  'mates-decline-invitation-description': 'El colega rechazó su solicitud de amistad',
  'mates-accept-invitation-title': 'Convite aceptado',
  'mates-accept-invitation-description': 'El colega aceptó su solicitud de amistad!',
  'noteboard-header-label': "Cuadro",
  'noteboard-btn-new-note': "Nuevo Billete",
  'noteboard-accordion-my-notes-label': "Mis Billetes",
  'noteboard-accordion-mates-notes-label': "Billetes de los colegas",
  'noteboard-my-notes-no-note': "Usted no ha escrito ningún billete",
  'noteboard-mates-notes-no-note': "Nada para mostrar aquí",
  'noteboard-btn-show-as-visitor': 'Ver como visitante',
  'signout-label': "A salir...",
  'spinner-default-label': "Cargando...",
  'api-mates-added-successfully': "Usuario agregado a su lista de colegas con éxito.",
  'api-mates-error-mate-already-added': "¡El dueño de este E-mail ya es su colega!",
  'api-mates-error-cannot-add-yourself': "Usted no puede agregarse como colega.",
  'api-mates-error-mate-not-found': "El E-mail proporcionado no pertence a ningún usuario registrado",
  'api-notes-error-uid-not-found': "Ningún usuario encontrado com este Uid",
  'api-notes-error-email-not-found': "Ningún usuario encontrado com este E-mail",
  'editnote-notify-users-title': "Un colega pegó un billete en su cuadro",
  'editnote-notify-users-description': "Haga clic aquí para ver",
  'editnote-published': "Sú billete ha sido publicado!",
  'editnote-error-empty-inputs': "Usted necesita proporcionar un título y un mensaje para publicar su billete",
  'editnote-accordion-item-notecolor-label': "Color del billete",
  'editnote-accordion-item-fontcolor-label': "Color de la fuente",
  'editnote-accordion-item-fontsize-label': "Tamaño de fuente",
  'editnote-accordion-item-mates-label': "Compartir el billete con estos colegas",
  'editnote-you-have-no-mates': "Usted no tiene ningún colega",
  'editnote-notetitle-placeholder': "El título del billete",
  'editnote-message-placeholder': "Su mensaje!",
  'editnote-btn-create': "Publicar",
  'editnote-title': "Personalice su billete",
  'editnote-accordion-item-note-attachments-label': 'Álbum de fotos',
  'editnote-attachment-already-added-warning': 'Esta URL ya ha sido agregada!',
  'editnote-attachment-empty-input-warning': 'Debe proporcionar una dirección URL para agregar una imagen',
  'editnote-accordion-item-attachments-picker-label': 'Introduzca una dirección URL y una descripción de la imagen',
  'editnote-add-attachment-url-placeholder': 'Pegar aquí la URL',
  'editnote-add-attachment-description-placeholder': 'Diga algo sobre esta imagen',
  'notepreview-created-by': "Creado por {owner}",
  'notepreview-attachments-label': "Ver los anexos",
  'userpresentation-contact-info-label': 'Información de contacto',
  'userpresentation-email-label': 'E-mail',
  'matenoteboard-notes-no-note': 'El usuario no tiene ningún billete',
  'matenoteboard-user-not-allowed': 'Usted no tiene permiso para ver este contenido',
  'settings-board-privacy-label': 'Cambiar la privacidad del cuadro',
  'settings-board-privacy-select-public': 'Público (visible a todos)',
  'settings-board-privacy-select-mates': 'Colegas (Sólo sus colegas pueden ver)',
  'settings-board-privacy-select-private': 'Privado (sólo tú puedes ver)',
  'attachment-viewer-title': 'Visualización de imagen',
  'attachment-viewer-filename-label': 'Nombre de archivo',
  'attachment-viewer-date-label': 'Publicado en',
  'attachment-viewer-description-label': 'Descripción',
}

export default es